/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Abort_ButtonInputs */

const en_work_order_publish_abort_button = /** @type {(inputs: Work_Order_Publish_Abort_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abort`)
};

const fr_work_order_publish_abort_button = /** @type {(inputs: Work_Order_Publish_Abort_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonner`)
};

const de_work_order_publish_abort_button = /** @type {(inputs: Work_Order_Publish_Abort_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const it_work_order_publish_abort_button = /** @type {(inputs: Work_Order_Publish_Abort_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aborto`)
};

const ru_work_order_publish_abort_button = /** @type {(inputs: Work_Order_Publish_Abort_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_work_order_publish_abort_button = /** @type {(inputs: Work_Order_Publish_Abort_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abortar`)
};

const zh_cn2_work_order_publish_abort_button = /** @type {(inputs: Work_Order_Publish_Abort_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中止`)
};

const ja_work_order_publish_abort_button = /** @type {(inputs: Work_Order_Publish_Abort_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アボート`)
};

const hi_work_order_publish_abort_button = /** @type {(inputs: Work_Order_Publish_Abort_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीच में बंद करें`)
};

const pt_pt2_work_order_publish_abort_button = /** @type {(inputs: Work_Order_Publish_Abort_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abortar`)
};

/**
* | output |
* | --- |
* | "Abort" |
*
* @param {Work_Order_Publish_Abort_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_abort_button = /** @type {((inputs?: Work_Order_Publish_Abort_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Abort_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_abort_button(inputs)
	if (locale === "de") return de_work_order_publish_abort_button(inputs)
	if (locale === "it") return it_work_order_publish_abort_button(inputs)
	if (locale === "ru") return ru_work_order_publish_abort_button(inputs)
	if (locale === "es") return es_work_order_publish_abort_button(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_abort_button(inputs)
	if (locale === "ja") return ja_work_order_publish_abort_button(inputs)
	if (locale === "hi") return hi_work_order_publish_abort_button(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_abort_button(inputs)
	return en_work_order_publish_abort_button(inputs)
});